<template>
  <div class="result-modal">
    <van-overlay :show="visible" :lock-scroll="true" :z-index="300">
      <div class="wrapper" @click.stop>
        <div class="content">
          <!-- <div v-if="resultType === 1" class="result-title">领取时间未开始</div>
          <div v-if="resultType === 2" class="result-title">
            用户暂不符合领取资格
          </div>
          <div
            v-if="resultType === 3"
            class="result-title"
            style="line-height: 1.3"
          >
            请选择其中<br />一个商品领取
          </div>
          <div
            v-if="resultType === 4"
            class="result-title"
            style="line-height: 1.3"
          >
            用户已领取过权益<br />请到领取记录查看
          </div> -->

          <div class="result-title">{{ message }}</div>
          <!-- <div class="result-title">用户已领取过权益请到领取记录查看</div> -->

          <div class="claim-wrap">
            <div class="claim-btn" @click="onClose">
              <span class="claim-btn__text">确定</span>
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
  <!-- 细则弹框组件 -->
</template>

<script>
export default {
  name: "ResultModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // resultType: {
    //   type: Number,
    //   default: 1, // 1: 领取时间未开始 2: 用户暂不符合领取资格 3: 未选择礼品 4: 用户已领取过权益
    // },
    message: {
      type: String,
      default: "",
    },
  },
  methods: {
    onClose() {
      this.$emit("confirm");
    },
  },
};
</script>

<style lang="less" scoped>
.result-modal {
  .wrapper {
    display: flex;
    align-items: center;
    height: 100vh;

    .content {
      background: url("~@/assets/imgs/xibReturnGift/result_bg.png") no-repeat;
      background-size: 100% 100%;
      height: 515px;
      width: 100vw;
      position: relative;

      .result-title {
        font-weight: bold;
        font-size: 24px;
        color: #ffffff;
        position: absolute;
        text-align: center;
        left: 22vw;
        right: 0;
        top: 225px;
        width: 56vw;
        line-height: 1.3;
      }

      .claim-wrap {
        position: absolute;
        left: 0;
        right: 0;
        top: 320px;
        display: flex;
        justify-content: center;
        pointer-events: auto;
        padding: 0 24px;
        box-sizing: border-box;

        .claim-btn {
          width: 158px;
          height: 68px;
          background: url("~@/assets/imgs/xibReturnGift/btn_claim_bg.png")
            no-repeat center;
          background-size: 100% 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          .claim-btn__text {
            font-size: 18px;
            font-weight: 400;
            color: #fff;
          }
        }
      }
    }
  }

  .close-btn {
    margin-top: 16px;
    width: 24px;
    height: 24px;

    img {
      width: 100%;
    }
  }
}
</style>
